<template>
    <div class="animated fadeIn">
        <div v-if="loading">
            <b-row>
                <b-col md="6">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="float-right my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <div v-if="!loading">
            <component-new-header
                title="Commission Rule"
                :isLoading="isloading"
                @reload-data="reloadData"
                @create-press="
                    $router.push({
                        name: 'partner-assign-commission',
                        params: { id: partnerAllData._id },
                    })
                "
                @search-query="(val) => (filter = val)"
            />
            <b-card class="card-wrap" border-variant="info">
                <div>
                    <b-table
                        class="table-style"
                        :dark="false"
                        :hover="true"
                        :striped="false"
                        :bordered="true"
                        :small="false"
                        :fixed="false"
                        responsive
                        :items="commissionRuleAssignList"
                        :fields="commissionRuleAssignColumns"
                        :current-page="currentPage"
                        :per-page="perPage"
                        thead-class="header"
                        :filter="filter"
                        show-empty
                    >
                        <!-- <template slot-scope="data" slot="commissionValue">
             <div v-for="value in data.item.restData.commissionrule.commission" :key="value">
             <v-row>
               <p>{{value.userType}} : {{value.rate*100}}%</p>
             </v-row>
             </div>
            </template> -->
                        <template slot="cell(status)" slot-scope="data">
                            <div v-if="data.item.restData.active">
                                <img src="img/Ellipse63.png" alt="" /> Active
                            </div>
                            <div v-if="!data.item.restData.active">
                                <img src="img/Ellipse6.png" alt="" /> Canceled
                            </div>
                        </template>
                        <template slot-scope="data" slot="cell(action)">
                            <b-button
                                @click="CancelPlan(data.item)"
                                size="sm"
                                v-model="active"
                                class="mr-2 my -0 main-navigation-button"
                                variant="danger"
                            >
                                Cancel
                            </b-button>
                        </template>
                        <template slot="cell(empty)">
                            <div v-if="isloading" class="text-center">
                                <span><b>Loading...</b></span>
                            </div>
                            <div v-else class="text-center">
                                No data available.
                            </div>
                        </template>
                    </b-table>
                </div>
                <div class="float-right">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="commissionRuleAssignList.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    >
                    </b-pagination>
                </div>
            </b-card>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import ebButton from "@/components/FormElements/Button";
import ComponentNewHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
export default {
    name: "CommissionRuleAssignList",
    data() {
        return {
            filter: "",
            loading: false,
            isloading: false,
            active: false,
            currentPage: 1,
            perPage: 8,
            commissionRuleAssignColumns: [
                {
                    key: "commissionRuleName",
                },
                {
                    key: "commissionRuleType",
                },
                {
                    key: "commissionValue",
                },
                {
                    key: "status",
                },
                {
                    key: "action",
                },
            ],
        };
    },
    components: {
        ebButton,
        ComponentNewHeader,
        AtomSpinner,
    },
    computed: {
        ...mapGetters({
            getFetchCommissionRuleAssign: "commission/GetCommissionRuleList",
            partnerAllData: "partner/GetPartnerData",
        }),
        commissionRuleAssignList() {
            let data = this.getFetchCommissionRuleAssign;
            if (Array.isArray(data) && data.length > 0) {
                return data.map((d) => {
                    return {
                        id: d._id,
                        commissionRuleName: d.ruleName,
                        commissionRuleType: d.ruleType,
                        commissionValue: d.commission.rate * 100 + " %",
                        restData: d,
                    };
                });
            }
            return [];
        },
    },
    methods: {
        async CancelPlan(data) {
            let payload = {
                id: data.id,
                data: {
                    active: false,
                },
            };
            this.$swal({
                title: "Cancel this Commission Rule?",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Cancel it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch(
                            "commission/cancelCommissionRuleAssign",
                            payload,
                        )
                        .then((result) => {
                            this.reloadData();
                            this.$swal({
                                title: "Success",
                                text: "Commission Canceled Successfully!",
                                type: "success",
                            });
                        })
                        .catch((err) => {
                            this.$swal({
                                title: "Sorry",
                                text: "Unable to Cancel Assign Commission Rule",
                                type: "error",
                            });
                        });
                }
            });
        },
        async reloadData() {
            this.isloading = true;
            await this.$store.dispatch(
                "commission/fetchCommissionRuleAssignList",
                this.partnerAllData._id,
            );
            this.isloading = false;
        },
    },
    async mounted() {
        this.loading = true;
        await this.$store.dispatch(
            "commission/fetchCommissionRuleAssignList",
            this.partnerAllData._id,
        );
        this.loading = false;
    },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
.table-style
  border-radius: 12px
</style>
